// extracted by mini-css-extract-plugin
export default {"drag_layer":"CustomDragLayer_drag_layer"};